// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TrophyTwoToneSvg from "@ant-design/icons-svg/es/asn/TrophyTwoTone";
import AntdIcon from '../components/AntdIcon';

var TrophyTwoTone = function TrophyTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: TrophyTwoToneSvg
  }));
};

TrophyTwoTone.displayName = 'TrophyTwoTone';
export default React.forwardRef(TrophyTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/TrophyTwoTone.js
// module id = 1963
// module chunks = 0